import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row mt-3" }
const _hoisted_2 = { class: "col-sm-12" }
const _hoisted_3 = { class: "card" }
const _hoisted_4 = { class: "card-header" }
const _hoisted_5 = { class: "mb-0" }
const _hoisted_6 = { class: "text-muted" }
const _hoisted_7 = { class: "card-body" }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "mb-3" }
const _hoisted_10 = { class: "form-check" }
const _hoisted_11 = ["checked"]
const _hoisted_12 = {
  for: "plan-none",
  class: "form-check-label"
}
const _hoisted_13 = { class: "form-check" }
const _hoisted_14 = ["id", "checked", "onChange"]
const _hoisted_15 = ["for"]
const _hoisted_16 = { class: "fw-bold" }
const _hoisted_17 = { class: "text-muted ms-2" }
const _hoisted_18 = { class: "badge bg-secondary badge-sm ms-2" }
const _hoisted_19 = {
  key: 0,
  class: "text-muted small mt-1"
}
const _hoisted_20 = {
  key: 2,
  class: "text-center text-muted"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoaderWrapper = _resolveComponent("LoaderWrapper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h6", _hoisted_5, _toDisplayString(_ctx.helper.trans("labels.plan_settings")), 1),
          _createElementVNode("small", _hoisted_6, _toDisplayString(_ctx.helper.trans("labels.plan_settings_description")), 1)
        ]),
        _createElementVNode("div", _hoisted_7, [
          (_ctx.loading)
            ? (_openBlock(), _createBlock(_component_LoaderWrapper, {
                key: 0,
                zoom: 0.5
              }, {
                default: _withCtx(() => _cache[1] || (_cache[1] = [
                  _createElementVNode("div", { class: "text-center" }, [
                    _createElementVNode("div", {
                      class: "spinner-border spinner-border-sm",
                      role: "status"
                    }, [
                      _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
                    ])
                  ], -1)
                ])),
                _: 1,
                __: [1]
              }))
            : (_ctx.planSettings && _ctx.planSettings.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("input", {
                        id: "plan-none",
                        checked: !_ctx.form.planId || _ctx.form.planId === null,
                        onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.togglePlan(null))),
                        class: "form-check-input",
                        type: "radio",
                        name: "planSelection"
                      }, null, 40, _hoisted_11),
                      _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.helper.trans('labels.none')), 1)
                    ])
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.planSettings, (setting) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: setting.id,
                      class: "mb-3"
                    }, [
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("input", {
                          id: `plan-${setting.id}`,
                          checked: _ctx.form.planId === setting.id,
                          onChange: ($event: any) => (_ctx.togglePlan(setting.id)),
                          class: "form-check-input",
                          type: "radio",
                          name: "planSelection"
                        }, null, 40, _hoisted_14),
                        _createElementVNode("label", {
                          for: `plan-${setting.id}`,
                          class: "form-check-label d-flex flex-column"
                        }, [
                          _createElementVNode("span", null, [
                            _createElementVNode("span", _hoisted_16, _toDisplayString(setting.name), 1),
                            _createElementVNode("span", _hoisted_17, "(" + _toDisplayString(_ctx.helper.trans('labels.currency')) + ": " + _toDisplayString(setting.currency) + ")", 1),
                            _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.helper.trans('plan_settings.plan_type_' + (setting.planType || 'mandatory'))), 1)
                          ]),
                          (_ctx.getDealAmountRangeText(setting))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_ctx.getDealAmountRangeText(setting)), 1))
                            : _createCommentVNode("", true)
                        ], 8, _hoisted_15)
                      ])
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _createElementVNode("small", null, _toDisplayString(_ctx.helper.trans('plan_settings.no_settings_available')), 1)
                ]))
        ])
      ])
    ])
  ]))
}